import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addRole } from "../../../api/roles";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useTranslation } from "react-i18next";

const AddRole = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [permissions, setPermissions] = useState([]);
  const allResources = ["Sales", "Management", "Monitor"];
  const allActions = ["create", "read", "update", "delete"];

  const togglePermission = (action, resource) => {
    const key = `${action} ${resource}`;
    if (permissions.includes(key)) {
      setPermissions(permissions.filter((p) => p !== key));
    } else {
      setPermissions([...permissions, key]);
    }
  };

  const handleFullAccess = (resource) => {
    const resourcePermissions = allActions.map(
      (action) => `${action} ${resource}`
    );
    // Check if all permissions for this resource are already selected
    const allSelected = resourcePermissions.every((perm) =>
      permissions.includes(perm)
    );
    if (allSelected) {
      // If all are selected, remove all permissions for this resource
      setPermissions(
        permissions.filter((perm) => !resourcePermissions.includes(perm))
      );
    } else {
      // If not all are selected, add all permissions for this resource
      setPermissions([...new Set([...permissions, ...resourcePermissions])]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const structuredPermissions = [];

      allResources.forEach((resource) => {
        const matchedActions = allActions.filter((action) =>
          permissions.includes(`${action} ${resource}`)
        );
        if (matchedActions.length > 0) {
          structuredPermissions.push({ resource, actions: matchedActions });
        }
      });

      await addRole({ name, permissions: structuredPermissions });
      alert("Role created successfully");
      navigate("/roles");
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert(err.response?.data?.message || err.message);
    }
  };

  return (
    <div className="container mt-4">
      <Breadcrumbs title={`${t("btns.Add")} ${t("New Role")}`} />
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Role Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <h4>Permissions</h4>
        <div className="permission-groups">
          {allResources.map((resource) => {
            const resourcePermissions = allActions.map(
              (action) => `${action} ${resource}`
            );
            const allSelected = resourcePermissions.every((perm) =>
              permissions.includes(perm)
            );

            return (
              <div key={resource} className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h5>{resource}</h5>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {allActions.map((action) => {
                    const key = `${action} ${resource}`;
                    const isSelected = permissions.includes(key);
                    return (
                      <button
                        type="button"
                        key={key}
                        onClick={() => togglePermission(action, resource)}
                        className={`btn btn-sm ${
                          isSelected ? "btn-success" : "btn-outline-secondary"
                        }`}
                      >
                        {action}
                      </button>
                    );
                  })}
                  <button
                    type="button"
                    onClick={() => handleFullAccess(resource)}
                    className={`btn btn-sm ${
                      allSelected ? "btn-success" : "btn-outline-secondary"
                    }`}
                  >
                    Full Access
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div>
          <button type="submit" className="btn btn-primary">
            Create Role
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddRole;
